import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.transaction
 * @constructor
 */
export class LineItemModel extends BaseModel {
  /**
   * @param {string} code
   * @param {loavies.models.base.PriceModel} unitPrice
   * @param {number|Object} quantity
   * @param {Array<string>} includeFor
   * @param {loavies.models.base.PriceModel} [lineTotal]
   */
  constructor({
    code,
    unitPrice,
    quantity,
    includeFor,
    lineTotal,
  }) {
    super()

    /** @type {string} */
    this.code = code

    /** @type {loavies.models.base.PriceModel} */
    this.unitPrice = unitPrice

    /** @type {number} */
    this.quantity = isNaN(quantity) && quantity.value ? Number(quantity.value) : quantity

    /** @type {Array<string>} */
    this.includeFor = includeFor

    /** @type {undefined|loavies.models.base.PriceModel} */
    this.lineTotal = lineTotal
  }

  /**
   * @returns {string|null}
   */
  getListingId() {
    const listingIdRegex = /line-item\/listing-(.+)/
    const match = this.code.match(listingIdRegex)

    return match?.[1] ?? null
  }
}
